var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"close-on-click-modal":false,"show-close":false,"close-on-press-escape":false,"visible":_vm.show},on:{"update:visible":function($event){_vm.show=$event}}},[_c('p',[_vm._v("Su contraseña esta a punto de expirar. Por favor cambie su contraseña")]),_c('the-change-password')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }